import React from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { ArrowDownward, ArrowUpward, ArrowForward, ArrowBack } from '@mui/icons-material';
import SegmentedControl from '../SegmentedControl';

const DIRECTION_OPTIONS = [
  { value: 'TB', title: 'Top to Bottom', icon: <ArrowDownward fontSize="small" /> },
  { value: 'BT', title: 'Bottom to Top', icon: <ArrowUpward fontSize="small" /> },
  { value: 'LR', title: 'Left to Right', icon: <ArrowForward fontSize="small" /> },
  { value: 'RL', title: 'Right to Left', icon: <ArrowBack fontSize="small" /> }
];

const LAYOUT_OPTIONS = [
  { value: 'default', label: 'Default' },
  { value: 'elk', label: 'Elk' }
];

const THEME_OPTIONS = ['default', 'dark', 'forest', 'neutral', 'base'];

/**
 * Diagram-level controls (direction, layout engine, theme), shared by Online
 * and Offline. Deliberately has no section heading: the labels name themselves
 * so the panel is one uninterrupted list and fits without scrolling.
 */
const DiagramOptions = ({ formData, onChange }) => (
  <Box sx={{ mb: 1 }}>
    <SegmentedControl
      label="Diagram direction"
      value={formData.direction}
      onChange={(value) => onChange('direction', value)}
      options={DIRECTION_OPTIONS}
    />

    <SegmentedControl
      label="Diagram layout engine"
      value={formData.layout}
      onChange={(value) => onChange('layout', value)}
      options={LAYOUT_OPTIONS}
    />

    <FormControl fullWidth size="small" sx={{ mb: 1.25 }}>
      <InputLabel>Diagram theme</InputLabel>
      <Select
        value={formData.theme}
        label="Diagram theme"
        onChange={(e) => onChange('theme', e.target.value)}
      >
        {THEME_OPTIONS.map((theme) => (
          <MenuItem key={theme} value={theme}>
            {theme.charAt(0).toUpperCase() + theme.slice(1)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Box>
);

export default DiagramOptions;
